import { AppState } from "../../../store/app.state";
import { ConnectedState, OwnProps } from "./info-neue-buchtsau.types";
import { getFilteredByWorkflowId } from "../../../store/prozess-events/prozess-events.selectors";
import { connect } from "react-redux";
import InfoNeueBuchtsauComponent from "./info-neue-buchtsau.component";
import { getFilteredFerkel } from "../../../store/ferkel/ferkel.selectors";

const mapStateToProps = (state: AppState, ownProps: OwnProps): ConnectedState => {
  const workflowId = ownProps.prozess.workflowId!;

  return {
    filteredBy: getFilteredByWorkflowId(workflowId)(state),
    ferkel: getFilteredFerkel(state),
  };
};

export default connect(mapStateToProps)(InfoNeueBuchtsauComponent);
